import Box from '@/gf/components/Box'
import ImageGallery from '@/gf/components/ImageGallery'
import MachineInformation from '../MachineInformation'
import { useRfqContext } from '../context'
import SidebarLayout from '../SidebarLayout'
import Comments from '../Comments'

const RequestCancelled = () => {
  const { rfq } = useRfqContext()

  return (
    <SidebarLayout className="flex flex-col sm:flex-row gap-x-6 flex-grow">
      <Box className="shadow-base flex-grow py-8 px-6 flex flex-col gap-y-4">
        <div className="space-y-2">
          <h4 className="text-lg font-medium">
            {rfq.nonparticipation ? <>Can&apos;t Participate</> : 'Request Canceled'}
          </h4>

          {rfq.nonparticipation && (
            <p>
              Reason:{' '}
              {rfq.nonparticipation.reason === 'Other'
                ? rfq.nonparticipation.details
                : rfq.nonparticipation.reason}
            </p>
          )}
        </div>

        <MachineInformation
          reqMachine={rfq.machines[0] ?? null}
          hideUnitNumber={rfq.user?.organization?.hideUnitNumberFromVendors ?? false}
        />

        {rfq.partsRequest && <Comments partsRequest={rfq.partsRequest} />}

        {rfq.images.length > 0 && <ImageGallery images={rfq.images.map((i) => i.url)} />}
      </Box>
    </SidebarLayout>
  )
}

export default RequestCancelled
